import { Container } from '@chakra-ui/react'
import { SentryErrorComponent } from '@components/Fallback'
import {
  DEFAULT_LIST_ORDER,
  staffSessionRequestSchema,
  STAFF_SESSION_ORDER_BY_FIELDS,
} from '@customTypes/cloudmix/sessions'
import { ListSessions } from '@features/staffMember/components/sessions/ListSessions'
import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { withListHydration } from '@lib/listState/withListHydration'

const StaffSessionsRoute = () => (
  <Container maxW={'75rem'}>
    <ListSessions />
  </Container>
)

const routerSchema = staffSessionRequestSchema.partial().catch({})
export const Route = createFileRoute('/_auth/staff/sessions')({
  component: StaffSessionsRoute,
  beforeLoad: withListHydration({
    list: {
      defaultSort: DEFAULT_LIST_ORDER,
      allowedOrderByFields: STAFF_SESSION_ORDER_BY_FIELDS,
    },
    getTitle: () => 'Sessions',
  }),
  errorComponent: SentryErrorComponent,
  validateSearch: zodValidator(routerSchema),
})
